<template>
  <div style="height: 100%">
    <h1 class="r-logo"></h1>
  </div>
</template>

<script>
  import {myMixins} from "@/utils/loginMixins";
  import storage from "store";
  import {ACCESS_TOKEN} from '@/store/mutation-types'

  export default {
    mixins: [myMixins],
    name: "Login",
    data() {
      return {
        username: '',
        password: '',
        flag: true
      }
    },
    created() {
      const token = storage.get(ACCESS_TOKEN)
      if (token) {
        this.$router.replace('/')
      }
    },
    methods: {}
  }
</script>

<style scoped>
  .r-logo {
    display: block;
    width: 92px;
    margin: 0 auto;
    margin-top: 80px;
  }

  .r-logo img {
    width: 92px;
  }

  .reg-box {
    margin: 0 26px;
    margin-top: 50px;
    padding: 0 22px;
  }

  .reg-box h2 {
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    padding: 38px 0;
  }

  .reg-box ul li {
    display: block;
    height: 40px;
    border-bottom: 1px solid #B9B9B9;
    background: #FFFFFF;
    background: url();
    margin-bottom: 20px;
    position: relative;
  }

  .reg-box ul li input {
    float: left;
    color: #333333
  }

  .reg-box ul li span {
    display: block;
    height: 29px;
    width: 25px;
    float: left;
    position: relative;
    top: 5px;
  }

  .reg-box ul li span img {
    width: 14px;
    position: relative;
    top: 5px;
    left: 0;
  }

  .reg-box ul li.code span img {
    width: 16px;
    position: relative;
    top: 6px;
    left: 0;
  }

  .reg-box ul li.phone input {
    display: block;
    height: 40px;
    width: calc(100% - 25px);
    color: #333333;
    font-size: 14px
  }

  .reg-box ul li.code input {
    display: block;
    height: 40px;
    width: calc(100% - 25px);
    color: #333333;
    font-size: 14px
  }

  .reg-box ul li.code label {
    display: inline-block;
    width: 100px;
    height: 34px;
    border-radius: 3px;
    background: #0066cc;
    color: #FFF;
    font-size: 12px;
    text-align: center;
    line-height: 34px;
    float: right;
    position: relative;
    top: 4px;
    right: 3px;
  }

  .reg-but input {
    height: 44px;
    border-radius: 3px;
    background: #3f797b;
    color: #FFF;
    font-size: 14px;
    text-align: center;
    line-height: 44px;
    border: none;
    width: 100%;
    margin-bottom: 40px;
    margin-top: 10px;
    border-radius: 100px;
    font-weight: bolder;
  }

</style>
